import { useQuery } from "react-query";
import endpoints from "./EndPoints";
import { getAlarmListFitler } from "./Services";



export const useGetAlarms= () => {
  return useQuery(
    [endpoints.getAlarmList],
    () => getAlarmListFitler(),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );
};
